import { useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Save } from "lucide-react";
import { api, apiError } from "@/lib/api";

const inp = "h-10 rounded-lg border border-gray-200 px-2 text-sm font-mono-num focus:ring-2 focus:ring-emerald-500 focus:outline-none";

const AttendanceLine = ({ a, day, onChanged }) => {
  const [v, setV] = useState({ clock_in: a.clock_in, clock_out: a.clock_out, note: a.note });
  const save = async () => {
    try {
      await api.put(`/attendance/${a.id}`, { day, clock_in: v.clock_in, clock_out: v.clock_out || null, note: v.note });
      toast.success("Timbratura aggiornata");
      onChanged();
    } catch (e) { toast.error(apiError(e)); }
  };
  const remove = async () => {
    try {
      await api.delete(`/attendance/${a.id}`);
      toast.success("Timbratura eliminata");
      onChanged();
    } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid={`day-att-${a.id}`} className="flex flex-wrap items-center gap-2">
      <input data-testid={`day-att-in-${a.id}`} type="time" value={v.clock_in} onChange={(e) => setV({ ...v, clock_in: e.target.value })} className={inp} />
      <span className="text-gray-400">→</span>
      <input data-testid={`day-att-out-${a.id}`} type="time" value={v.clock_out} onChange={(e) => setV({ ...v, clock_out: e.target.value })} className={inp} />
      <input data-testid={`day-att-note-${a.id}`} value={v.note} onChange={(e) => setV({ ...v, note: e.target.value })} placeholder="Nota" className={`${inp} font-sans flex-1 min-w-[140px]`} />
      {a.break_minutes ? <span className="text-xs text-amber-700">pausa {a.break_minutes}m</span> : null}
      <button data-testid={`day-att-save-${a.id}`} onClick={save} className="h-9 px-3 rounded-lg bg-emerald-600 text-white text-xs font-semibold flex items-center gap-1"><Save className="h-3.5 w-3.5" /> Salva</button>
      <button data-testid={`day-att-delete-${a.id}`} onClick={remove} aria-label="Elimina timbratura" className="h-9 w-9 rounded-lg border border-red-200 text-red-600 flex items-center justify-center hover:bg-red-50"><Trash2 className="h-3.5 w-3.5" /></button>
    </div>
  );
};

export const DayAttendanceEditor = ({ operatorId, day, onChanged }) => {
  const [n, setN] = useState({ clock_in: "09:00", clock_out: "13:00", note: "" });
  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/attendance", { operator_id: operatorId, day: day.date, ...n, clock_out: n.clock_out || null });
      toast.success("Timbratura aggiunta");
      setN({ ...n, note: "" });
      onChanged();
    } catch (err) { toast.error(apiError(err)); }
  };
  return (
    <div className="space-y-3" data-testid="day-attendance-editor">
      <h3 className="text-sm font-semibold">Timbrature</h3>
      {day.attendances.length === 0 && <p className="text-xs text-gray-500">Nessuna timbratura registrata in questo giorno.</p>}
      {day.attendances.map((a) => <AttendanceLine key={a.id} a={a} day={day.date} onChanged={onChanged} />)}
      <form onSubmit={add} className="flex flex-wrap items-center gap-2 rounded-lg border border-dashed border-gray-300 p-3 bg-gray-50">
        <span className="text-xs text-gray-600 w-full sm:w-auto">Nuova:</span>
        <input data-testid="day-new-in" type="time" required value={n.clock_in} onChange={(e) => setN({ ...n, clock_in: e.target.value })} className={inp} />
        <span className="text-gray-400">→</span>
        <input data-testid="day-new-out" type="time" value={n.clock_out} onChange={(e) => setN({ ...n, clock_out: e.target.value })} className={inp} />
        <input data-testid="day-new-note" value={n.note} onChange={(e) => setN({ ...n, note: e.target.value })} placeholder="Nota (opzionale)" className={`${inp} font-sans flex-1 min-w-[140px]`} />
        <button data-testid="day-new-add" className="h-9 px-3 rounded-lg bg-emerald-600 text-white text-xs font-semibold flex items-center gap-1"><Plus className="h-3.5 w-3.5" /> Aggiungi</button>
      </form>
    </div>
  );
};
